import React from 'react';

import {FormItem} from './BaseFormField';

import type {FormItemProps} from './BaseFormField';

interface Props extends Omit<FormItemProps, 'children'> {
  disabled?: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => unknown;
  value: boolean;
  name: string;
}

export function CheckboxField({
  id,
  name,
  value,
  onChange,
  disabled,
  ...props
}: Props) {
  return (
    <FormItem id={id} {...props}>
      <div>
        <input
          id={id}
          name={name}
          disabled={disabled}
          type="checkbox"
          checked={value}
          onChange={onChange}
          className="form-control"
        />
      </div>
    </FormItem>
  );
}
